<template>
  <AddOrEdit
    ref="form"
    :edit="true"
    :editData="product"
    :type="product.type"
    @updated="fetchProduct(true)"
    v-if="product"
  />
</template>

<script>

import AddOrEdit from '@/partials/Products/AddOrEdit.vue';

export default {
  components: {
    AddOrEdit,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    async fetchProduct(reset = false) {
      const { id } = this;
      const product = await this.$store.dispatch('Products/getProduct', id);
      this.product = product;
      this.$nextTick(() => {
        if (reset) {
          this.$refs.form.reset();
        }
      });
    },
  },
  data() {
    return {
      product: null,
    };
  },
  async mounted() {
    this.fetchProduct();
  },
};
</script>
